/**
 * Service for interact with the transaction API to make donations
 */

// vendors
import { Injectable } from '@angular/core';
import { Donation } from "./donation";
import { OptionService } from "../option/option.service";
import { Contact } from "../contact/contact";
import {HttpClient} from "@angular/common/http";


@Injectable()
export class DonationService {

    /**
     * The end point for starting a transaction
     * @type {string}
     */
    public static TRANSACTION_START = "transaction/start/";

    /**
     * The end point for updating a transaction
     * @type {string}
     */
    public static TRANSACTION_UPDATE = "transaction/update/";

    /**
     * constructor
     * @param http
     */
    constructor (private http: HttpClient) {}

    /**
     * Starts a donation on the transaction API
     * @param donation
     * @param contact
     */
    public startDonation(donation: Donation, contact: Contact = null): any {
        let contactMandatory = OptionService.getOptionStatic("has_contact_mandatory");
        let hasExtraField = OptionService.getOptionStatic("extra_field");

        // check if there is already an iframe. if yes, remove it.
        let oldIframe = document.getElementsByName("payment");
        if(oldIframe && oldIframe.length > 0) {
            document.body.removeChild(oldIframe[0]);
        }
        // create an iframe
        let iframe = document.createElement("iframe");
        iframe.name = "payment";
        document.body.appendChild(iframe);

        // Check if there is already an old form. if yes, remove it
        let oldPaymentForm = document.getElementById("paymentform");
        if(oldPaymentForm) {
            document.body.removeChild(oldPaymentForm);
        }

        // Create a form
        let mapForm = document.createElement("form");
        mapForm.target = "payment";
        mapForm.id = "paymentform";
        mapForm.method = "POST";
        mapForm.action = OptionService.getTransactionApiHost() + DonationService.TRANSACTION_START;

        // Create an input
        let mapInput = document.createElement("input");
        mapInput.type = "text";
        mapInput.name = "value";
        donation.contactData = contact;

        mapInput.value = JSON.stringify(donation);

        // Add the input to the form
        mapForm.appendChild(mapInput);

        // Add the form to dom
        document.body.appendChild(mapForm);

        // Just submit
        mapForm.submit();
    }

    /**
     * Updates the donation
     * @param contact
     * @param transactionGuid
     */
    public updateDonation(contact: Contact, transactionGuid: any): any {
        return this.http.post(OptionService.getTransactionApiHost() + DonationService.TRANSACTION_UPDATE + transactionGuid, contact);
    }
}
